module.exports = __webpack_public_path__ + "img/3.959a2ad3.png";